<div class="container-box">
  <div class="flex mt-3 mb-2">
    <div class="dynamic-form mx-4 my-2 w-3/12">
      <app-make-dropdown-ms
        [meta]="brandsMeta"
        [triggerSelectionBrand$]="triggerSelectionBrand$"
        [triggerUpdateComponent$]="triggerUpdateComponentSelectBrand$"
      ></app-make-dropdown-ms>
    </div>
    <div class="dynamic-form mx-4 w-9/12 text-right align-bottom">
      <app-button
        (btnClicked)="uploadDocument()"
        [additionalClass]="'mb-4'"
        [content]="'Carica Documento'"
        [faIcon]="faUpload"
        [showIcon]="true"
      ></app-button>
    </div>
  </div>
  <div class="table-container">
    <app-new-table
      (btnDeleteClickEvent)="btnDeleteClick($event)"
      [dataSource]="dataSource"
      [customButtons]="customButtons"
      [reloadTrigger$]="reloadTrigger$"
      [displayedColumns]="displayedColumns"
      [initialSort]="{ active: 'id', direction: 'desc' }"
      [triggerSelectorBrand$]="triggerSelectionBrand$"
      [additionalFilters]="{ brandId: brandIdDefault }"
    ></app-new-table>
  </div>
</div>
